import { render, staticRenderFns } from "./JobLeader.vue?vue&type=template&id=b010efc2&scoped=true"
import script from "./JobLeader.vue?vue&type=script&lang=js"
export * from "./JobLeader.vue?vue&type=script&lang=js"
import style0 from "./JobLeader.vue?vue&type=style&index=0&id=b010efc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b010efc2",
  null
  
)

export default component.exports